"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncAction = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _root = require("../util/root");

var _Action2 = require("./Action");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsyncAction =
/*#__PURE__*/
function (_Action) {
  (0, _inherits2.default)(AsyncAction, _Action);

  function AsyncAction(scheduler, work) {
    var _this;

    (0, _classCallCheck2.default)(this, AsyncAction);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AsyncAction).call(this, scheduler, work));
    _this.scheduler = scheduler;
    _this.work = work;
    _this.pending = false;
    return _this;
  }

  (0, _createClass2.default)(AsyncAction, [{
    key: "schedule",
    value: function schedule(state) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this.closed) {
        return this;
      } // Always replace the current state with the new state.


      this.state = state; // Set the pending flag indicating that this action has been scheduled, or
      // has recursively rescheduled itself.

      this.pending = true;
      var id = this.id;
      var scheduler = this.scheduler; //
      // Important implementation note:
      //
      // Actions only execute once by default, unless rescheduled from within the
      // scheduled callback. This allows us to implement single and repeat
      // actions via the same code path, without adding API surface area, as well
      // as mimic traditional recursion but across asynchronous boundaries.
      //
      // However, JS runtimes and timers distinguish between intervals achieved by
      // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
      // serial `setTimeout` calls can be individually delayed, which delays
      // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
      // guarantee the interval callback will be invoked more precisely to the
      // interval period, regardless of load.
      //
      // Therefore, we use `setInterval` to schedule single and repeat actions.
      // If the action reschedules itself with the same delay, the interval is not
      // canceled. If the action doesn't reschedule, or reschedules with a
      // different delay, the interval will be canceled after scheduled callback
      // execution.
      //

      if (id != null) {
        this.id = this.recycleAsyncId(scheduler, id, delay);
      }

      this.delay = delay; // If this action has already an async Id, don't request a new one.

      this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
      return this;
    }
  }, {
    key: "requestAsyncId",
    value: function requestAsyncId(scheduler, id) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return _root.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    }
  }, {
    key: "recycleAsyncId",
    value: function recycleAsyncId(scheduler, id) {
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      // If this action is rescheduled with the same delay time, don't clear the interval id.
      if (delay !== null && this.delay === delay && this.pending === false) {
        return id;
      } // Otherwise, if the action's delay time is different from the current delay,
      // or the action has been rescheduled before it's executed, clear the interval id


      return _root.root.clearInterval(id) && undefined || undefined;
    }
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */

  }, {
    key: "execute",
    value: function execute(state, delay) {
      if (this.closed) {
        return new Error('executing a cancelled action');
      }

      this.pending = false;

      var error = this._execute(state, delay);

      if (error) {
        return error;
      } else if (this.pending === false && this.id != null) {
        // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
      }
    }
  }, {
    key: "_execute",
    value: function _execute(state, delay) {
      var errored = false;
      var errorValue = undefined;

      try {
        this.work(state);
      } catch (e) {
        errored = true;
        errorValue = !!e && e || new Error(e);
      }

      if (errored) {
        this.unsubscribe();
        return errorValue;
      }
    }
  }, {
    key: "_unsubscribe",
    value: function _unsubscribe() {
      var id = this.id;
      var scheduler = this.scheduler;
      var actions = scheduler.actions;
      var index = actions.indexOf(this);
      this.work = null;
      this.state = null;
      this.pending = false;
      this.scheduler = null;

      if (index !== -1) {
        actions.splice(index, 1);
      }

      if (id != null) {
        this.id = this.recycleAsyncId(scheduler, id, null);
      }

      this.delay = null;
    }
  }]);
  return AsyncAction;
}(_Action2.Action);

exports.AsyncAction = AsyncAction;